import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const CREATE_CODE_CONTENT_SNIPPET = gql`
  mutation createCodeContentSnippet(
    $containerId: Int!
    $visible: Boolean!
    $locationId: String!
  ) {
    contentSnippet {
      createContentSnippet(
        baseSnippet: { containerId: $containerId, visible: $visible }
        contentSnippetCode: { locationId: $locationId }
      ) {
        id
        sort
      }
    }
  }
`;

const createCodeContentSnippetRequest = ({
  containerId,
  isVisible,
  locationId,
  onError,
  onSuccessResult,
}) => (
  <Mutation mutation={CREATE_CODE_CONTENT_SNIPPET}>
    {(createContentSnippet, { loading, error, data }) => {
      const variables = {
        containerId,
        visible: isVisible,
        locationId,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(
          data.contentSnippet.createContentSnippet.id,
          data.contentSnippet.createContentSnippet.sort
        );
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={createContentSnippet}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

createCodeContentSnippetRequest.propTypes = {
  containerId: PropTypes.number.isRequired,
  isVisible: PropTypes.bool.isRequired,
  locationId: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
};

export default createCodeContentSnippetRequest;
